import { IFormConfig, IFieldDefinition, IFieldContainer } from 'app/interfaces';
import {fieldsMap} from './../fields';

const fields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('entity_id'),
	fieldsMap.get('description'),
	fieldsMap.get('age_range_code'),
	fieldsMap.get('nation_code'),
	fieldsMap.get('channel_ticket_code')
];

const baseInfoFormConfig: IFormConfig = {
	formStyle: 'style-1',
	fields
};

export default baseInfoFormConfig;
